import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useAppSelector } from "app/hooks";
import { getSelectedMatch } from "app/reducers/matchesSlice";
import { MATCH_STATUS } from "interfaces/Match";
import { useMemo } from "react";
import { HeadsetStatus } from "ui";
import Dot, { VARIANT } from "ui/Dot";

type Props = {
  containerNumber?: number;
  connectionState: boolean;
  playerName?: string;
  matchState: keyof typeof MATCH_STATUS;
  matchId: string;
  headsetName: string;
  battery: number;
  onClick: () => void;
};

export const getMatchStateDot = (matchState?: keyof typeof MATCH_STATUS) => {
  switch (matchState) {
    case "STANDBY":
      return <Dot variant={VARIANT.WARNING} />;
    case "READY":
      return <Dot variant={VARIANT.SUCCESS} />;
    case "IN_PROGRESS":
      return <Dot variant={VARIANT.INFO} />;
    case "COMPLETE":
      return <Dot variant={VARIANT.SUCCESS} />;
    default:
      return <></>;
  }
};

export const ContainerCard = ({
  containerNumber,
  connectionState,
  playerName,
  matchState,
  matchId,
  headsetName,
  battery,
  onClick,
}: Props) => {
  const { selectedMatch } = useAppSelector(getSelectedMatch);

  const isSelected = useMemo(
    () => selectedMatch?._id === matchId,
    [matchId, selectedMatch?._id],
  );

  return (
    <section
      className={`box-border flex flex-col w-[500px] h-[200px] p-6 rounded-md shadow cursor-pointer bg-faux-gunmetal ${isSelected && "border-2"}`}
      onClick={onClick}
    >
      <header>
        <div className="flex flex-row items-center justify-between pb-3">
          <h1 className="mr-8 text-white text-xl">
            Contenedor {containerNumber}
          </h1>
          <HeadsetStatus
            isConnected={connectionState}
            batteryValue={battery}
            className="text-lg"
          />
        </div>
        <div className="flex justify-between mt-8 text-faux-shadow-blue">
          <div className="flex flex-col mb-2">
            <span className="flex items-center mr-1 font-bold text-xs pb-2">
              Jugador
            </span>
            <div className="flex gap-3">
              <span className="text-sm text-white"> {playerName}</span>
            </div>
          </div>
          <div className="flex flex-col">
            <span className="flex items-center mr-1 font-bold text-xs pb-2">
              Casco
            </span>
            <span className="text-sm text-white">{headsetName}</span>
          </div>
          <div className="flex flex-col">
            <span className="flex items-center mr-1 font-bold pb-2 text-xs">
              Estado de la partida
            </span>
            <p className="flex text-white text-sm">
              {getMatchStateDot(matchState)}
              {MATCH_STATUS[matchState]}
            </p>
          </div>
        </div>
      </header>
      <div className="flex justify-end">
        <MoreHorizIcon
          className="cursor-pointer text-faux-cadet hover:text-white"
          fontSize="medium"
        />
      </div>
    </section>
  );
};
